import React, {useEffect, useRef} from "react";
import isMaxUser from "../../utils/isMaxUser";
import {addToCart} from "../../../analytics/AddToCart/dispatchAddToCartSubmitted";
import {isProductExclusive} from "../Exclusive/exclusiveData";
import ReactDOM from "react-dom";
import Exclusive from "../Exclusive/Exclusive";
import BonusGift from "../BonusGift/BonusGift";
import {isProductBonusGift} from "../BonusGift/bonusGiftData";

const ADD_TO_CART_USER_TYPE_MAX = "max";
const ADD_TO_CART_USER_TYPE_NONMAX = "";
const ADD_TO_CART_UNIT_1_MAX = 1;
const ADD_TO_CART_UNIT_2_MAX = 2;
const ADD_TO_CART_UNIT_1_NONMAX = "ONE";
const ADD_TO_CART_UNIT_2_NONMAX = "TWO";

const BONUS_GIFT_CAMPAIGN_START_DATE = new Date("2025-05-01T00:00:00.000+10:00");
const BONUS_GIFT_CAMPAIGN_END_DATE = new Date("2025-07-31T23:59:59.999+10:00");

const isWithinBonusGiftCampaignDateRange = () => {
  const today = new Date();
  return today >= BONUS_GIFT_CAMPAIGN_START_DATE && today <= BONUS_GIFT_CAMPAIGN_END_DATE;
}

const mapUserTypeForAddToCart = isMaxUserType => isMaxUserType ? ADD_TO_CART_USER_TYPE_MAX : ADD_TO_CART_USER_TYPE_NONMAX;

const mapUnitForAddToCart = (isMaxUserType, unit1, unit2, selectedUnit) => {
  const isUnit2Selected = selectedUnit === unit2

  if (isMaxUserType) {
    return isUnit2Selected ? ADD_TO_CART_UNIT_2_MAX : ADD_TO_CART_UNIT_1_MAX;
  }
  return isUnit2Selected ? ADD_TO_CART_UNIT_2_NONMAX : ADD_TO_CART_UNIT_1_NONMAX;
};

const workaroundBooleanWebComponentAttribute = (key, booleanValue) => {
  return (
    booleanValue
      ? { [key]: booleanValue }
      : {}
  );
};

const AddToCart = ({
  priceType,
  productCode,
  productTitle,
  quantity,
  gstInclusivePrice,
  cmpGstInclusivePrice,
  selectedUnitOfMeasure,
  unitOfMeasure1,
  unitOfMeasure2,
  userType,
  disabled,
  stockAvailabilityStatus
}) => {
  const refHandler = useRef();
  const isMaxUserType = isMaxUser(userType);

  function clickHandler(e){
    addToCart(e,e.currentTarget.gstInclusivePrice,e.currentTarget.productTitle,e.currentTarget.stockAvailabilityStatus);
  }

  function renderExclusive(domain, domainCountry) {
    const showExclusive = isProductExclusive(productCode, domainCountry)
    const elExclusive = document.getElementById("campaign-container");
    if(elExclusive && showExclusive) {
      ReactDOM.render(<Exclusive domainCountry={domainCountry}/>, elExclusive);
    }
  }

  function renderBonusGift(domain, domainCountry) {
    const showBonusGift = isProductBonusGift(productCode, domainCountry)
    const elBonusGift = document.getElementById("campaign-container");
    if(elBonusGift && showBonusGift && isWithinBonusGiftCampaignDateRange()) {
      ReactDOM.render(<BonusGift domainCountry={domainCountry}/>, elBonusGift);
    }
  }

  useEffect(() => {
    if(isMaxUserType) {
      const domain = window.location.hostname
      const domainCountry = domain.endsWith(".nz") ? "NZ" : "AU"
      renderExclusive(domain, domainCountry);
      renderBonusGift(domain, domainCountry);
    }
  }, []);

  useEffect(() => {
    if(refHandler && cmpGstInclusivePrice) {
      (refHandler.current).stockAvailabilityStatus = stockAvailabilityStatus;
      (refHandler.current).addEventListener('click',clickHandler);
      if(priceType === "MY_PRICE") {
        (refHandler.current).gstInclusivePrice = gstInclusivePrice;
        (refHandler.current).productTitle = productTitle
      }
      return () => {
        (refHandler.current).removeEventListener('click', clickHandler);
      };
    }
  } ,[gstInclusivePrice,cmpGstInclusivePrice,stockAvailabilityStatus])

  return (
    <add-to-cart
      ref={refHandler}
      {...workaroundBooleanWebComponentAttribute('disabled', disabled)}
      user-type={mapUserTypeForAddToCart(isMaxUserType)}
      data-product-number={productCode}
      data-product-name={productTitle}
      data-unit-of-measure1={unitOfMeasure1}
      data-unit-of-measure2={unitOfMeasure2}
      data-quantity={quantity}
      data-cmp-gst-inclusive-price={cmpGstInclusivePrice}
      data-gst-inclusive-price={gstInclusivePrice}
      data-unit={mapUnitForAddToCart(isMaxUserType, unitOfMeasure1, unitOfMeasure2, selectedUnitOfMeasure)}
    >
      Add
    </add-to-cart>
  );
};

export default AddToCart;
